/**
 * VD Quick Add Pill — Final
 * - Tek varyant: AJAX cart add
 * - Çok varyant: mevcut Root Theme quick-add tetiklenir
 * - Drawer: cart-drawer:refresh + Root Theme toggleDrawerClasses()
 * - Dinamik filtre / infinite-scroll kartlarını destekler
 */
(function () {
  'use strict';

  const SHOPIFY_ROOT = window.Shopify?.routes?.root || '/';
  const CART_ADD_URL = `${SHOPIFY_ROOT}cart/add.js`;
  const INIT_ATTR = 'data-vd-qap-init';

  function setState(btn, state) {
    const icons = {
      plus: btn.querySelector('.vd-qap__icon--plus'),
      check: btn.querySelector('.vd-qap__icon--check'),
      loading: btn.querySelector('.vd-qap__icon--loading'),
    };

    Object.values(icons).forEach((el) => el?.setAttribute('hidden', ''));
    btn.removeAttribute('data-state');
    btn.removeAttribute('aria-busy');

    if (state === 'idle') {
      icons.plus?.removeAttribute('hidden');
    }

    if (state === 'loading') {
      icons.loading?.removeAttribute('hidden');
      btn.setAttribute('data-state', 'loading');
      btn.setAttribute('aria-busy', 'true');
    }

    if (state === 'added') {
      icons.check?.removeAttribute('hidden');
      btn.setAttribute('data-state', 'added');
    }
  }

  function openCartDrawer() {
    const drawerEl = document.querySelector('cart-drawer');
    if (!drawerEl || drawerEl.isOpen) return;

    if (typeof drawerEl.toggleDrawerClasses === 'function') {
      drawerEl.toggleDrawerClasses();
    }
  }

  function refreshAndOpenCartDrawer() {
    document.dispatchEvent(
      new CustomEvent('cart-drawer:refresh', { bubbles: true })
    );

    /*
     * Root Theme refresh event'i callback/promise sunmadığı için drawer açılışını
     * refresh event'inden hemen sonraki iki animation frame'e bırakıyoruz.
     * Bu, sabit 300 ms timeout'a göre daha deterministik ve hızlıdır.
     */
    requestAnimationFrame(() => {
      requestAnimationFrame(openCartDrawer);
    });
  }

  async function addToCart(btn) {
    const variantId = btn.dataset.variantId;
    if (!variantId || btn.dataset.state === 'loading') return;

    setState(btn, 'loading');

    try {
      const response = await fetch(CART_ADD_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1,
            },
          ],
        }),
      });

      if (!response.ok) {
        let payload = null;
        try {
          payload = await response.json();
        } catch (_) {
          // JSON olmayan hata yanıtını sessizce geç.
        }

        const message =
          payload?.description || payload?.message || 'Quick add failed';
        throw new Error(message);
      }

      setState(btn, 'added');
      refreshAndOpenCartDrawer();

      window.setTimeout(() => {
        if (document.body.contains(btn)) setState(btn, 'idle');
      }, 2500);
    } catch (error) {
      console.warn('[VD Quick Add Pill]', error);
      setState(btn, 'idle');

      /* Root Theme / başka entegrasyonlar isterse bu event'i dinleyebilir. */
      document.dispatchEvent(
        new CustomEvent('vd-qap:error', {
          bubbles: true,
          detail: {
            message: error?.message || 'Quick add failed',
            button: btn,
          },
        })
      );
    }
  }

  function findQuickAdd(btn) {
    /* Önce en yakın görsel container; sonra daha geniş olası kart wrapper'ları. */
    const containers = [
      btn.closest('.card__picture-container'),
      btn.closest('.card'),
      btn.closest('[data-product-card]'),
      btn.closest('li'),
    ].filter(Boolean);

    for (const container of containers) {
      const quickAddEl = container.querySelector('quick-add');
      if (quickAddEl) return quickAddEl;
    }

    return null;
  }

  function triggerQuickAdd(btn) {
    const quickAddEl = findQuickAdd(btn);

    if (quickAddEl) {
      const trigger = quickAddEl.querySelector(
        'button:not([disabled]), [role="button"]:not([aria-disabled="true"])'
      );

      if (trigger) {
        trigger.click();
        return;
      }
    }

    const url = btn.dataset.productUrl;
    if (url) window.location.href = url;
  }

  function handleClick(event) {
    const btn = event.currentTarget;

    if (
      btn.disabled ||
      btn.dataset.available === 'false' ||
      btn.dataset.state === 'loading'
    ) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (btn.dataset.multiVariant === 'true') {
      triggerQuickAdd(btn);
    } else {
      addToCart(btn);
    }
  }

  function initButton(btn) {
    if (!(btn instanceof HTMLElement) || btn.hasAttribute(INIT_ATTR)) return;

    btn.setAttribute(INIT_ATTR, '');
    setState(btn, 'idle');
    btn.addEventListener('click', handleClick);
  }

  function init(root = document) {
    if (root instanceof Element && root.matches('[data-vd-qap]')) {
      initButton(root);
    }

    root
      .querySelectorAll?.(`[data-vd-qap]:not([${INIT_ATTR}])`)
      .forEach(initButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target || document);
  });

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) init(node);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
